export const MF_PARTICULAR_HOLDING_DATA = "MF_PARTICULAR_HOLDING_DATA";
export const MF_PARTICULAR_HOLDING_START_LOADER = "MF_PARTICULAR_HOLDING_START_LOADER";
export const MF_PARTICULAR_HOLDING_STOP_LOADER = "MF_PARTICULAR_HOLDING_STOP_LOADER";
export const MF_PARTICULAR_HOLDING_ERROR = "MF_PARTICULAR_HOLDING_ERROR";
export const MF_PARTICULAR_HOLDING_HIDE_ERROR = "MF_PARTICULAR_HOLDING_HIDE_ERROR";
